var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarLoader',{staticClass:"m-auto",attrs:{"color":'#343a40',"width":240,"height":8,"loading":true}})}
var staticRenderFns = []

export { render, staticRenderFns }